import React from 'react';
import { ShowcaseBoxContent } from '../../../types/content';
import WalletTopBanner from './WalletTopBanner';
import Fixedprice from '../FixedPrice';
import { getAmount } from '../../../utils';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

interface IBoxOneProps {
  content: ShowcaseBoxContent;
}

const BoxOne = ({ content }: IBoxOneProps) => {
  const app = useSelector((state: RootState) => state.app);

  return (
    <div className='guide-box guide-box__one'>
      <WalletTopBanner
        title={content.banner.title}
        originAmount={0}
        targetAmount={content.banner.target_amount}
      />
      <div className='middle-box-section'>
        {content.boxes.map((box, index) => (
          <div
            className={`middle-box-section__item ${
              index === 1 ? 'active' : ''
            }`}
            key={`amount_${index}`}
          >
            <Fixedprice price={getAmount(box)} width={20} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoxOne;
